(() => {
  const initializedSections = new WeakSet();

  function normalize(value) {
    return (value || "").toString().trim().toLocaleLowerCase();
  }

  function getSections(root = document) {
    if (root.matches && root.matches(".clp-collections")) return [root];
    return [...root.querySelectorAll(".clp-collections")];
  }

  function sortCards(cards, sortValue) {
    return [...cards].sort((a, b) => {
      if (sortValue === "az" || sortValue === "za") {
        const titleA = normalize(a.dataset.clpTitle);
        const titleB = normalize(b.dataset.clpTitle);
        return sortValue === "az" ? titleA.localeCompare(titleB) : titleB.localeCompare(titleA);
      }

      const indexA = Number(a.dataset.clpIndex || 0);
      const indexB = Number(b.dataset.clpIndex || 0);
      return indexA - indexB;
    });
  }

  function setupCollectionList(section) {
    if (initializedSections.has(section)) return;

    const grid = section.querySelector("[data-clp-grid]");
    const cards = [...section.querySelectorAll("[data-clp-card]")];
    const filterToggle = section.querySelector("[data-clp-filter-toggle]");
    const filterPanel = section.querySelector("[data-clp-filter-panel]");
    const filterInput = section.querySelector("[data-clp-filter-input]");
    const filterClear = section.querySelector("[data-clp-filter-clear]");
    const sortToggle = section.querySelector("[data-clp-sort-toggle]");
    const sortMenu = section.querySelector("[data-clp-sort-menu]");
    const sortLabel = section.querySelector("[data-clp-sort-label]");
    const emptyMessage = section.querySelector("[data-clp-empty]");

    if (!grid || cards.length === 0) return;

    initializedSections.add(section);

    let filterQuery = "";
    let sortValue = "featured";

    function closePanel(panel, toggle) {
      if (!panel || !toggle) return;
      panel.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
    }

    function togglePanel(panel, toggle) {
      if (!panel || !toggle) return;

      const willOpen = panel.hidden;
      closePanel(filterPanel, filterToggle);
      closePanel(sortMenu, sortToggle);

      panel.hidden = !willOpen;
      toggle.setAttribute("aria-expanded", String(willOpen));

      if (willOpen && panel === filterPanel && filterInput) {
        window.requestAnimationFrame(() => filterInput.focus());
      }
    }

    function applyState() {
      const orderedCards = sortCards(cards, sortValue);
      let visibleCount = 0;

      orderedCards.forEach((card) => {
        grid.appendChild(card);

        const title = normalize(card.dataset.clpTitle);
        const isVisible = filterQuery === "" || title.includes(filterQuery);
        card.hidden = !isVisible;

        if (isVisible) visibleCount += 1;
      });

      if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
    }

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener("click", () => togglePanel(filterPanel, filterToggle));
    }

    if (filterInput) {
      filterInput.addEventListener("input", () => {
        filterQuery = normalize(filterInput.value);
        applyState();
      });
    }

    if (filterClear) {
      filterClear.addEventListener("click", () => {
        filterQuery = "";
        if (filterInput) {
          filterInput.value = "";
          filterInput.focus();
        }
        applyState();
      });
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener("click", () => togglePanel(sortMenu, sortToggle));

      sortMenu.addEventListener("click", (event) => {
        const option = event.target.closest("[data-clp-sort-value]");
        if (!option) return;

        sortValue = option.dataset.clpSortValue || "featured";

        sortMenu.querySelectorAll("[data-clp-sort-value]").forEach((button) => {
          button.setAttribute("aria-current", button === option ? "true" : "false");
        });

        if (sortLabel && option.dataset.clpSortText) {
          sortLabel.textContent = option.dataset.clpSortText;
        }

        closePanel(sortMenu, sortToggle);
        applyState();
      });
    }

    section.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closePanel(filterPanel, filterToggle);
      closePanel(sortMenu, sortToggle);
    });

    document.addEventListener("click", (event) => {
      if (section.contains(event.target)) return;
      closePanel(filterPanel, filterToggle);
      closePanel(sortMenu, sortToggle);
    });

    applyState();
  }

  function init(root = document) {
    getSections(root).forEach(setupCollectionList);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
